import { CSSProperties, ReactNode } from 'react';
import { SuperSelectProps } from "../SuperSelect/interface";
import { InputNumberProps, InputProps, SelectProps } from 'antd';

export type IntervalTypeFormItemType = 'Input' | 'InputNumber' | 'NumberInterval' | 'SelectTags';
export interface IntervalTypeOption {
  /** 标题 */
  label?: ReactNode;
  /** 值 */
  value?: string;
  /** 表单类型 */
  formItemType?: IntervalTypeFormItemType;
  /** 末尾文字 */
  afterNode?: string;
  /** Input表单属性 */
  inputProps?: InputProps;
  /** InputNumber属性 */
  inputNumberProps?: InputNumberProps;
  /** NumberInterval属性 */
  inputNumbersProps?: [InputNumberProps | undefined, InputNumberProps | undefined];
  /** SelectTags属性 */
  selectTagsProps?: SelectProps;
}
export interface IntervalTypeProps {
  /** 选项 */
  options?: IntervalTypeOption[];
  /** 下拉框配置 */
  superSelectProps?: SuperSelectProps
  /** 值 */
  value?: IntervalTypeValue;
  /** 默认值，仅在初始化时有效 */
  defauleValue?: IntervalTypeValue;
  /** 下拉框所占长度比重 */
  selectFlex?: number;
  /** 数字区间所占长度比重 */
  intervalFlex?: number;
  /** 若为区间，中间分割的文字 */
  intervalSplitText?: string;
  /** 若为SelectTags，中间分割的文字 */
  tagsSplitText?: string;
  /** 是否禁用 */
  disabled?: boolean;
  /** 禁用是显示内容 */
  disabledRender?: ReactNode;
  /** 禁用文字溢出隐藏 */
  disabledEllipsis?: boolean;
  /** 禁用文字下边框虚线 */
  disabledBorder?: boolean;
  /** 值改变回调 */
  onChange?: (value?: IntervalTypeValue) => void;
};

export interface IntervalTypeValue {
  /** 类型 */
  type?: any;
  /** 区间 */
  interval?: any | any[];
};
/** 数字输入框公共样式 */
export const inputNumberStyle: CSSProperties = { width: '100%' };
